<template>
    <div class="org-select-container">
        <org-select-pop
            v-if="mode === 'pop'"
            v-bind="$attrs"
            v-on="$listeners"
        >
            <template slot="trigger">
                <slot name="trigger" />
            </template>
        </org-select-pop>
        <org-select-dialog
            v-else-if="mode === 'dialog'"
            ref="dialog"
            v-bind="$attrs"
            v-on="$listeners"
        >
            <template slot="trigger">
                <slot name="trigger" />
            </template>
            <template slot="status-tip">
                <slot name="status-tip" />
            </template>
            <template slot="footer">
                <slot name="footer" />
            </template>
        </org-select-dialog>
        <org-select-inner
            v-else
            v-bind="$attrs"
            v-on="$listeners"
        />
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';
import OrgSelectInner from './org-select-inner';
import OrgSelectPop from './org-select-pop';
import OrgSelectDialog from './org-select-dialog';

const req = require.context('./assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
  components: {
    OrgSelectInner,
    OrgSelectPop,
    OrgSelectDialog,
  },
  props: {
    // 组件显示模式 dialog 弹框模式
    mode: {
      type: String,
      default() {
        return 'innner';
      },
    },
  },
  data() {
    return {};
  },

  computed: {
    hasTrigger() {
      return this.mode === 'pop' || this.mode === 'dialog';
    },
  },

  methods: {},
};
</script>

<style lang="less">
@import './style.less';
</style>
